// apps/client/src/ui/screens/confirmRemove.tsx (M1-T15) — the mayor confirms removing a public object (spec §4.4, D-39). OK sends
// `object.remove` and closes on success; the `object.removed` event then removes the view for everyone.
import type { StringKey } from '@whiskerton/content';
import type { ObjectId } from '@whiskerton/shared';
import { useState } from 'react';
import { useCommands } from '../../game/instance';
import { useT } from '../i18n';
import { Button, Panel } from '../kit';
import type { ScreenDef } from '../router';

declare module '../router' { interface ScreenParams { confirmRemove: { obj: ObjectId; name: StringKey } } }

function ConfirmRemove({ params, close }: { params: { obj: ObjectId; name: StringKey }; close: () => void }) {
  const t = useT();
  const cmd = useCommands();
  const [busy, setBusy] = useState(false);
  const ok = async () => {
    setBusy(true);
    const res = await cmd.act('object.remove', { obj: params.obj });
    setBusy(false);
    if (res.ok) close();
  };
  return (
    <Panel title={t('hud.verbRemove')}>
      <div style={{ display: 'grid', gap: 14, width: 340, maxWidth: '100%' }}>
        <p style={{ margin: 0 }}>{t('world.removeConfirm', { object: t(params.name) })}</p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <Button variant="quiet" onClick={close}>{t('common.cancel')}</Button>
          <Button disabled={busy} onClick={() => void ok()}>{t('common.ok')}</Button>
        </div>
      </div>
    </Panel>
  );
}
export const screen: ScreenDef<'confirmRemove'> = { id: 'confirmRemove', layer: 'panel', component: ({ params, close }) => <ConfirmRemove params={params} close={close} /> };
